import { Button } from '@astryxdesign/core/Button';
import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { VStack } from '@astryxdesign/core/VStack';
import { Compass, LinkSimpleBreak } from '@phosphor-icons/react';
import { useRouteError } from 'react-router';
import { envError } from '@/lib/env';
import { AppProviders } from './AppProviders';
import { DEFAULT_ACCENT } from './theme';

/** `/` carries no studio of its own: every studio has its own link. */
export function RootPage() {
  return (
    <AppProviders accent={DEFAULT_ACCENT}>
      <Center minHeight="100svh">
        <VStack padding={6} maxWidth={420}>
          <EmptyState
            icon={<Compass size={32} />}
            title="Онлайн-запись"
            description={envError ?? 'Откройте ссылку своей студии — она выглядит как …/s/название-студии/'}
          />
        </VStack>
      </Center>
    </AppProviders>
  );
}

export function NotFoundPage() {
  return (
    <AppProviders accent={DEFAULT_ACCENT}>
      <Center minHeight="100svh">
        <VStack padding={6} maxWidth={420}>
          <EmptyState
            icon={<LinkSimpleBreak size={32} />}
            title="Страница не найдена"
            description="Проверьте ссылку."
            actions={<Button label="Назад" onClick={() => history.back()} />}
          />
        </VStack>
      </Center>
    </AppProviders>
  );
}

export function RouteErrorPage() {
  const err = useRouteError();
  console.error(err);
  return (
    <AppProviders accent={DEFAULT_ACCENT}>
      <Center minHeight="100svh">
        <VStack padding={6} maxWidth={420}>
          <EmptyState
            title="Что-то сломалось"
            description="Обновите страницу. Если не поможет — позвоните в студию."
            actions={<Button label="Обновить" variant="primary" onClick={() => location.reload()} />}
          />
        </VStack>
      </Center>
    </AppProviders>
  );
}
